export const encryptionKeys = {
  IV: '7g5y6fdlctdegihj',
  key: '5pa7nohechag5j2'
};

export const SignUpType = {
  Email: 1,
  Phone: 2
};

export const OtpType = {
  SignUp: 1,
  Verification: 2,
  Forgot: 3,
  login:4
};
